import CreditReportClient from '@/api/CampusAdmin/CreditReportsClient';
import moment from 'moment';

export default class CreditCountsReport{
  constructor() {
    this.creditReportClient = null;
    this.schoolId = 0;
    this.loading = false;

    this.parameters = {
      from: null,
      through: null,
      customCampusTags: [],
    };
    this.individual = {};
    this.workshop = {};
  }
  initialize($http, schoolId) {
    this.creditReportClient = new CreditReportClient($http);
    this.schoolId = schoolId;

    return this;
  }

  between(from, through) {
    this.parameters.from = !!from ? moment(from) : null;
    this.parameters.through = !!through ? moment(through) : null;

    return this;
  }

  withCustomTags(tags) {
    this.parameters.customCampusTags = tags
    return this;
  }

  async fetch() {
    try {
      this.loading = true;
      const response = await this.creditReportClient.getCountsReport(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.customCampusTags
      );

      this.individual = response.individual;
      this.workshop = response.workshop;
    } finally {
      this.loading = false;
    }
  }
}